import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { RoundCard, RunnerUpHeader, UnderLine } from "../../../ui";
import Breadcrumb from "../../../library/components/BreadCrumbs";
import Button from "../../../library/components/Button";
import InputField from "../../../library/components/InputField";
import SelectField from "../../../library/components/Select";
import { Validators } from "../../../library/utilities/Validator";
import UploadFile from "../../../library/components/FileUpload/index";
import {
  useFinalizeEPBByROMutation,
  useSaveEpbDetailMutation,
  useGetEpbDetailQuery,
  useSaveBallotFileMutation,
} from "../../../services/finalizeGenerateViewTransmitService";
import {
  useGetDistrictRequestQuery,
} from "../../../services/announceElection";
import {
  REQUEST_APPROVAL,
  FILED_IS_REQUIRED,
  FILL_ALL_FIELDS,
  TRY_AFTER_SOME_TIME,
  ENTER_VALID_PINCODE,
  ENTER_VALID_ADDRESS,
} from "../../../constants/constants";
// import "../../../css/common.css";
import "./returningOfficer.css";

import {
  useGetObjectStoreFileQuery,
  useSubmitObjectStoreUploadMutation,
} from "../../../services/objectStoreServices";
import { parseJwt } from "../../utilities/utils";
import CustomModal from "../../../library/components/Modal/modal";
import ConfirmationModal from "../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import LeftMenu from "../../AnalyticsModule/Left";
import NoElection from "../../NoElection";
import moment from "moment";
import { ALERT_TYPE_INFO } from "../../../constants/constants";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../features/alert/alerts";
import { useRef } from "react";
import { useGetElectionDetailsQuery, useGetStatesRequestQuery } from "../../../services/announceElection";
import { useVerifyBallotMutation } from "../../../services/epbAndEpbPinService";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";


export default function ReturningOfficer({ refetch, epbdetails }) {
  const { data: electionDetails } = useGetElectionDetailsQuery("Transmitting");
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [deleteFileFlag, setDeleteFileFlag] = useState(true);
  const [FileError, setFileError] = useState();
  const [uploadFlag, setUploadFlag] = useState(false);
  const [filesKey, setFilesKey] = useState("");
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [files, setFiles] = useState();
  const stateList = [{ value: "", label: "State" }];
  const [distList, setDistList] = useState([
    { value: "", label: "Select District" },
  ]);
  const { data: getEpbDetails, refetch: getrefetch } = useGetEpbDetailQuery();
  const [saveBallotFile] = useSaveBallotFileMutation();
  const [verifyBallot ] = useVerifyBallotMutation()
  const dispatch = useDispatch();
  const [data, setData] = useState({
    id: "",
    roAddressLine1: "",
    roAddressLine2: "",
    stateCode: "",
    constNo: "",
    constType: "",
    districtName: "",
    pin: "",
    stateName: "",
    createdBy: "",
    createdDttm: "",
    modifiedBy: "",
    modifiedDttm: "",
    ballotPaperPath: "",
    saveFlag: "",
    finalizeFlag: "",
    epbPaperFlag: "",
    ballotFileFlag: "",
    epbPaperPath: "",
  });
  const [btnDisable, setbtnDisable] = useState(false);
  const [errorValue, setErrorValue] = useState({});
  const { data: getAllState } = useGetStatesRequestQuery();
  const [saveEpbDetails, { data: Data }] = useSaveEpbDetailMutation();
  const [finalizeEpbDetails] = useFinalizeEPBByROMutation();
  var [uploadData, response] = useSubmitObjectStoreUploadMutation();
  const { data: fileObject } = useGetObjectStoreFileQuery(
    data.ballotPaperPath,
    { skip: !data.ballotPaperPath }
  );

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
  const [
    showConfirmationPopupToSaveBallot,
    setShowConfirmationPopupToSaveBallot,
  ] = useState(false)
  const [
    showConfirmationPopupToSave,
    setShowConfirmationPopupToSave,
  ] = useState(false)
  const ref = useRef()
  let userState = parseJwt(localStorage.access_token).authorizedStates?.[0]
  let constType = parseJwt(localStorage.access_token)?.constituencyType
  let userAc =
    constType === "AC"
      ? parseJwt(localStorage.access_token).authorizedAcs?.[0]
      : constType === "PC"
      ? parseJwt(localStorage.access_token).authorizedPcs?.[0]
      : "";
      
  let userDist = parseJwt(localStorage.access_token).authorizedDistricts?.[0];
  const { data: getdistrictById } = useGetDistrictRequestQuery(userState);
  const location = useLocation();

  useEffect(() => {
    if (getEpbDetails?.payload) {
      let dataPayload = getEpbDetails?.payload;
      setData((prev) => ({
        ...prev,
        ["id"]: dataPayload.id,
        ["roAddressLine1"]: dataPayload.roAddressLine1,
        ["roAddressLine2"]: dataPayload.roAddressLine2,
        ["stateCode"]: dataPayload.stateName,
        ["districtName"]:dataPayload.districtName !== null
         ? dataPayload.districtName:"",
          // dataPayload.districtName !== null
          //   ? dataPayload.districtName
          //   : getdistrictById?.filter((item) => {
          //       return item.districtCd === userDist;
          //     })?.[0]?.districtValue,
        ["pin"]: dataPayload.pin,
        ["stateName"]:
          dataPayload.stateName !== null
            ? dataPayload.stateName
            : getAllState?.filter((item) => {
                return item.stateCd === userState;
              })?.[0].stateName,
        ["createdBy"]: dataPayload.createdBy,
        ["createdDttm"]: dataPayload.createdDttm,
        ["constNo"]: dataPayload.constNo,
        ["constType"]: dataPayload.constType,
        ["createdDttm"]: dataPayload.createdDttm,
        ["modifiedBy"]: dataPayload.modifiedBy,
        ["modifiedDttm"]: dataPayload.modifiedDttm,
        ["ballotPaperPath"]: dataPayload.ballotPaperPath,
        ["saveFlag"]: dataPayload.saveFlag,
        ["finalizeFlag"]: dataPayload.finalizeFlag,
        ["epbPaperFlag"]: dataPayload.epbPaperFlag,
        ["ballotFileFlag"]: dataPayload.ballotFileFlag,
        ["epbPaperPath"]: dataPayload.epbPaperPath,
        ["ballotVerificationFlag"]:dataPayload.ballotVerificationFlag
      }));
      if (electionDetails) {
        if (electionDetails?.refId && electionDetails?.refId !== null) {
          setbtnDisable(true);
        } else {
          setbtnDisable(dataPayload?.saveFlag === "Y");
        }
      }
    }
  }, [getEpbDetails, getAllState, getdistrictById, electionDetails]);

  useEffect(() => {
    let districts = [];
    getdistrictById?.map((item) => {
      districts.push({
        value: item.districtValue,
        label: item.districtValue,
      });
    });
    setDistList(districts);
  }, [getdistrictById]);

  useEffect(() => {
    let file = fileObject?.file;
    if (file !== "N/A" && file !== null && file !== "" && file !== undefined) {
      const binaryString = window.atob(file);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      setFiles(new Blob([bytes], { type: "application/pdf" }));
    }
  }, [fileObject]);

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };

  const onSaveBallotFile = () => {
    // if (uploadFlag) {
    let error = {};

    if (!data.ballotPdf || data.ballotPdf === "") {
      error["ballotPdf"] = "This Field is required";
    }

    setShowConfirmationPopupToSaveBallot(false)
    if (Object.keys(error).length) {
      setErrorValue(error);
      onInfo("Please choose the file first");
      return;
    }
    let formdata = new FormData();
    formdata.append("bucketName", "");
    formdata.append("file", files);
    formdata.append("fileType", files?.type);
    formdata.append("fileName", files?.name);
    formdata.append("stateCode", userState);
    formdata.append("acNo", `${constType}${userAc}`);
    formdata.append("type", `ETPBMS`);

    if (formdata !== null && formdata !== {} && !FileError) {
      uploadData(formdata)
        .then((res) => {
          if (res?.error) {
            setIsFileUpload(false);
          } else {
            setIsFileUpload(false);
            setUploadFlag(false);
            ref.current.removeFile();
            saveBallotFile({
              id: data.id,
              ballotpaperpath: res?.data?.refId,
              epbPaperPath: data.epbPaperPath,
              stateCode: data.stateCode,
              constType: data.constType,
              constNo: data.constNo,
            })
              .unwrap()
              .then((response) => {
                getrefetch();
                refetch();

                setIsPreviewed(false);
                window.scrollTo(0,0);
              })
              .catch((err) => {});
          }
        })
        .catch((err) => {
          setIsFileUpload(false);

        });
    } else {
      setIsFileUpload(false);
    }
    // }
  };

  const onSaveAddress = async () => {
    let error = {};
    if (!data.roAddressLine1 || data.roAddressLine1 === "") {
      error["roAddressLine1"] = "This field is required";
    }

    if (!data.roAddressLine2 || data.roAddressLine2 === "") {
      error["roAddressLine2"] = "This Field is required";
    }

    // if (
    //   !data.stateCode ||
    //   data.stateCode === '' ||
    //   data.stateCode === undefined ||
    //   data.stateCode === null
    // ) {
    //   error['stateCode'] = 'This Field is required'
    // }

    // if (!data.districtName || data.districtName === '') {
    //   error['districtName'] = 'This Field is required'
    // }

    if (!data.pin || data.pin === "") {
      error["pin"] = "This Field is required";
    } else if (
      data.pin != "" &&
      !new RegExp("^[1-9]{1}[0-9]{2}\\s{0,1}[0-9]{3}$").test(data.pin)
    ) {
      error["pin"] = "Please enter valid PinCode";
    }

    if (Object.keys(error).length) {
      setErrorValue(error);
      return;
    }
    setShowConfirmationPopupToSave(true)
  }

  const onFinalize = () => {
    let error = {};
    if (!data.roAddressLine1 || data.roAddressLine1 === "") {
      error["roAddressLine1"] = "This field is required";
    }

    if (!data.roAddressLine2 || data.roAddressLine2 === "") {
      error["roAddressLine2"] = "This Field is required";
    }

    // if (
    //   !data.stateCode ||
    //   data.stateCode === '' ||
    //   data.stateCode === undefined ||
    //   data.stateCode === null
    // ) {
    //   error['stateCode'] = 'This Field is required'
    // }

    // if (!data.districtName || data.districtName === '') {
    //   error['districtName'] = 'This Field is required'
    // }

    if (!data.pin || data.pin === "") {
      error["pin"] = "This Field is required";
    }

    if (Object.keys(error).length) {
      setErrorValue(error);
      return;
    }
    setShowConfirmationPopup(true);
  };

  const uploadChangeHandler = (key, event) => {
    let files = event.target.files?.[0];
    let formdata = new FormData();
    formdata.append("file", files);
    // if(data?.ballotVerificationFlag){
    //   verifyBallot(formdata).unwrap().then((res)=>{
    //     if(res?.message==="valid"){
    //       setData((prevState) => ({
    //         ...prevState,
    //         ballotPdf: files,
    //       }));
    //       setUploadFlag(true);
    //       setFilesKey(key);
    //       setFiles(files);
    //       setIsFileUpload(true);
    //       setIsPreviewed(false);
    //     }
    //     else{
    //       onInfo(res?.message)
    //       ref.current.removeFile();
    //     }
    //   }).catch(()=>{
    //     ref.current.removeFile();
    //   })
    // }else{
    //   setData((prevState) => ({
    //     ...prevState,
    //     ballotPdf: files,
    //   }));
    //   setUploadFlag(true);
    //   setFilesKey(key);
    //   setFiles(files);
    //   setIsFileUpload(true);
    //   setIsPreviewed(false);
    // }
    verifyBallot({verificationFlag:data?.ballotVerificationFlag,file:formdata}).unwrap().then((res)=>{
      if(res?.message==="valid"){
        setData((prevState) => ({
          ...prevState,
          ballotPdf: files,
        }));
        setUploadFlag(true);
        setFilesKey(key);
        setFiles(files);
        setIsFileUpload(true);
        setIsPreviewed(false);
      }
      else{
        onInfo(res?.message)
        ref.current.removeFile();
      }
    }).catch(()=>{
      ref.current.removeFile();
    })
  };

  const resetFile = (resetType, key) => {
    setUploadType(resetType);
    setData({ ...data, [key]: "" });
    setDeleteFileFlag(false);
    setFiles();
  };

  const getErrorValue = (key, value) => {
    let error = { ...errorValue };
    if (value && value.message) {
      setErrorValue({ ...errorValue, [key]: value.message });
    } else {
      delete error[key];
      setErrorValue(error);
    }
  };

  const finalizeAddress = () => {
    finalizeEpbDetails({
      roAddressLine1: data.roAddressLine1,
      roAddressLine2: data.roAddressLine2,
      stateName: data.stateName,
      districtName: data.districtName,
      pin: parseInt(data.pin),
    })
      .unwrap()
      .then((res) => {
        getrefetch();
      })
      .catch((err) => {
        console.log(err);
      });
    setbtnDisable(true);
    setShowConfirmationPopup(false);
  };

  return (
    <>
      <div className="RO">
        {
          <CustomModal
            className="confirmation_modal"
            show={showConfirmationPopup}
            onClose={() => {
              setShowConfirmationPopup(false);
            }}
            size="500px"
            closeIcon={false}
            modalTitle={"Do you want to finalize ?"}
            children={
              <div>
                <p
                  style={{ fontSize: '14px', fontWeight: 'bold', color: 'red' }}
                >
                  <span
                    style={{
                      color: 'red',
                      fontSize: '14px',
                    }}
                  >
                    Note:{' '}
                  </span>
                  This is the address where you will receive the marked postal
                  ballot, Therefore ensure that, The below mentoined address is the
                  complete postal address with correct State, District and
                  Pincode.
                </p>
                <p
                  style={{
                    color: 'black',
                    fontSize: '15px',
                    fontWeight: 'bold',
                  }}
                  className="box"
                >
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 'bold',
                    }}
                  >
                    Address: <br></br>
                    To, THE RETURNING OFFICER <br></br>
                    ({getEpbDetails?.payload?.designation}) <br></br>
                  </span>
                  {`${data.roAddressLine1} ${data.roAddressLine2}, ${data.stateName}, ${data.districtName} - ${data.pin}`}
                </p>
                <ConfirmationModal
                // title="You want to delete this"
                noOption={() => {
                  setShowConfirmationPopup(false);
                }}
                yesOption={finalizeAddress}
              />
              </div>
            }
          />
        }
        {
          <CustomModal
            className="confirmation_modal"
            show={showConfirmationPopupToSaveBallot}
            onClose={() => {
              setShowConfirmationPopupToSaveBallot(false)
            }}
            size="500px"
            closeIcon={false}
            modalTitle={`Are you sure you want to upload ?`}
            children={
              <div>
                <p
                  style={{ fontSize: '17px', fontWeight: 'bold', color: 'red' }}
                >
                  <span
                    style={{
                      color: 'red',
                      fontSize: '17px',
                    }}
                  >
                    Note:{' '}
                  </span>
                  {`Please ensure that you are uploading correct ballot for ${constType}`}
                </p>
                <ConfirmationModal
                  // title="You want to delete this"
                  noOption={() => {
                    setShowConfirmationPopupToSaveBallot(false)
                  }}
                  yesOption={onSaveBallotFile}
                />
              </div>
            }
          />
        }
        {
          <CustomModal
            className="confirmation_modal"
            show={showConfirmationPopupToSave}
            onClose={() => {
              setShowConfirmationPopupToSave(false)
            }}
            size="500px"
            closeIcon={false}
            modalTitle={'Do you want to save this address ?'}
            children={
              <div>
                <p
                  style={{ fontSize: '14px', fontWeight: 'bold', color: 'red' }}
                >
                  <span
                    style={{
                      color: 'red',
                      fontSize: '14px',
                    }}
                  >
                    Note:{' '}
                  </span>
                  This is the address where you will receive the marked postal
                  ballot, Therefore ensure that, The below mentoined address is the
                  complete postal address with correct State, District and
                  Pincode.
                </p>
                <p
                  style={{
                    color: 'black',
                    fontSize: '15px',
                    fontWeight: 'bold',
                  }}
                  className="box"
                >
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 'bold',
                    }}
                  >
                    Address: <br></br>
                    To, THE RETURNING OFFICER <br></br>
                    ({getEpbDetails?.payload?.designation}) <br></br>
                  </span>
                  {`${data.roAddressLine1} ${data.roAddressLine2}, ${data.stateName}, ${data.districtName} - ${data.pin}`}
                </p>
                <ConfirmationModal
                  // title="You want to delete this"
                  noOption={() => {
                    setShowConfirmationPopupToSave(false)
                  }}
                  yesOption={() => {
                    saveEpbDetails({
                      roAddressLine1: data.roAddressLine1,
                      roAddressLine2: data.roAddressLine2,
                      stateName: data.stateName,
                      districtName: data.districtName,
                      pin: parseInt(data.pin),
                    })
                      .unwrap()
                      .then((res) => {
                        let responseData = res?.payload
                        if (responseData) {
                          setbtnDisable(true)
                          getrefetch()
                          setData((prev) => ({
                            ...prev,
                            ['id']: responseData.id,
                          }))
                          // setreturnObjectId(responseData.id)
                        } else {
                          onInfo(res.message)
                        }
                      })
                      .catch((error) => {
                        alert(error)
                      })

                    setShowConfirmationPopupToSave(false)
                  }}
                />
              </div>
            }
          />
        }

        <div className="container box my-2">
          <div className="ml-2 mr-2">
            <h6 style={{ textAlign: "center" }}>Upload Ballot</h6>
          </div>
          <div className="ml-2 mr-2">
            <RunnerUpHeaderNew title={"Enter RO Address"}
                state={  <span
                  >
                    State: {getEpbDetails?.payload?.stateName}{" "}
                    <span style={{marginLeft: "13px"}}></span>Constituency :{" "}
                    {userAc}-
                    {getEpbDetails?.payload?.constName} -{" "}
                    {getEpbDetails?.payload?.constType}
                  </span>}
             />
          </div>
          <div className="row">
            <div className="col-md-4 requiredMark">
              <label className="ml-3">Address Line 1</label>
            </div>
            <div className="col-md-4 mt-0 ml-2">
              <InputField
                inputClass="col-md-12"
                name="roAddressLine1"
                disabled={btnDisable}
                required={true}
                maxLength={100}
                value={data.roAddressLine1}
                onChange={(val) => handleChange("roAddressLine1", val)}
                getError={(value) => getErrorValue("roAddressLine1", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  }, 
                  {
                    check: Validators.nospecialReason,
                    message: "Special Character are not allowed",
                  },
                ]}
                getErrorValue={(val) => getErrorValue("roAddressLine1", val)}
                Error={errorValue}
              />
              <p
                className="text-danger"
                style={{ marginLeft: "15px", marginTop: "-16px" }}
              >
                *max length 100 charcaters
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 requiredMark">
              <label className="ml-3">Address Line 2</label>
            </div>
            <div className="col-md-4 mt-0 ml-2">
              <InputField
                inputClass="col-md-12"
                name="roAddressLine2"
                disabled={btnDisable}
                required={true}
                maxLength={100}
                value={data.roAddressLine2}
                onChange={(val) => handleChange("roAddressLine2", val)}
                getError={(value) => getErrorValue("roAddressLine2", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  }, 
                  {
                    check: Validators.nospecialReason,
                    message: "Special Character are not allowed",
                  },
                ]}
                getErrorValue={(val) => getErrorValue("roAddressLine2", val)}
                Error={errorValue}
              />
              <p
                className="text-danger"
                style={{ marginLeft: "15px", marginTop: "-16px" }}
              >
                *max length 100 characters
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 requiredMark">
              <label className="ml-3">State</label>
            </div>
            <div className="col-md-5 mt-0 ml-2">
              <InputField
                disabled={true}
                inputClass="col-md-6"
                //  labelClass=""
                name="stateCode"
                options={stateList}
                value={data.stateName}
                onChange={(val) => handleChange('stateCode', val)}
                getError={(value) => getErrorValue('stateCode', value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  },
                ]}
                getErrorValue={(val) => getErrorValue("stateCode", val)}
                Error={errorValue}
              ></InputField>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 requiredMark">
              <label className="ml-3">Select District</label>
            </div>
            {constType === 'PC' ? (
              <div className="col-md-5 mt-0 ml-2">
                <InputField
                  inputClass="col-md-6"
                  //  labelClass=""
                  name="districtName"
                  disabled={btnDisable}
                  value={data.districtName}
                  onChange={(val) => handleChange('districtName', val)}
                  getError={(value) => getErrorValue('districtName', value)}
                  validators={[
                    {
                      check: Validators.required,
                      message: FILED_IS_REQUIRED,
                    },
                  ]}
                  getErrorValue={(val) => getErrorValue('districtName', val)}
                  Error={errorValue}
                ></InputField>
              </div>
            ) : (
              <div className="col-md-5 mt-0 ml-2">
                <SelectField
                  // disabled={true}
                  inputClass="col-md-6"
                  labelClass="d-none"
                  style={{ fontSize: '12px' }}
                  name="districtName"
                  disabled={btnDisable}
                  options={distList}
                  value={data.districtName}
                  handleChange={(val) => handleChange('districtName', val)}
                  getError={(value) => getErrorValue('districtName', value)}
                  validators={[
                    {
                      check: Validators.required,
                      message: FILED_IS_REQUIRED,
                    },
                  ]}
                  getErrorValue={(val) => getErrorValue('districtName', val)}
                  Error={errorValue}
                ></SelectField>
              </div>
            )}
          </div>
          <div className="row mt-3">
            <div className="col-md-4 requiredMark">
              <label className="ml-3">Enter Pincode</label>
            </div>
            <div className=" col-md-5 mt-2 ml-2">
              <InputField
                name="pin"
                disabled={btnDisable}
                maxLength={6}
                required={true}
                type="number"
                inputClass="col-md-6 "
                // labelClass="C"
                value={data.pin}
                onChange={(val) => {
                  if (val.length > 6) {
                    return;
                  }
                  handleChange("pin", val);
                }}
                getError={(value) => getErrorValue("pin", value)}
                validators={[
                  {
                    check: Validators.pincode,
                    message: ENTER_VALID_PINCODE,
                  },
                ]}
                getErrorValue={(val) => getErrorValue("pin", val)}
                Error={errorValue}
              />
            </div>
          </div>
          <div className="">
            <div className="col-md-4 offset-4 pl-4">
              {electionDetails?.refId === null ? (
                <>
                  {" "}
                  <div className="button-row">
                    {btnDisable ? null : (
                      <>
                        <Button
                          value="save"
                          onClick={onSaveAddress}
                          btnClass="blue-button"
                          disabled={
                            data.finalizeFlag && data.finalizeFlag === "Y"
                          }
                        />
                      </>
                    )}
                    {data?.finalizeFlag === "Y" ? null : btnDisable ? (
                      <Button
                        value="Edit"
                        btnClass="white-btn"
                        onClick={() => setbtnDisable(false)}
                        disabled={
                          data.finalizeFlag && data.finalizeFlag === "Y"
                        }
                      />
                    ) : null}
                  </div>
                  <div className="ml-2 mb-3">
                    <UnderLine />
                  </div>
                  <div className="button-row ">
                    {data?.saveFlag === null ? null : data?.finalizeFlag !==
                        "Y" && btnDisable ? (
                      <Button
                        value="finalize"
                        onClick={onFinalize}
                        btnClass="blue-button"
                        disabled={
                          data.finalizeFlag && data.finalizeFlag === "Y"
                        }
                      />
                    ) : null}
                  </div>
                </>
              ) : (
                <h3 className="text-danger">{electionDetails?.refId}</h3>
              )}
            </div>
          </div>
          {data.finalizeFlag && data.finalizeFlag === "Y" && data.epbPaperFlag!=='Y'  ? (
            <div className="row my-2">
              <div className="col-md-4">
                <label className="ml-3">Upload e-PB</label>
              </div>
              <div className="col-md-8 ">
                <UploadFile
                  id="Ballot Pdf"
                  name="ballotPdf"
                  labelClass="col-md-0"
                  inputClass="col-md-5 "
                  label=""
                  // disabled={
                  //   data.deathCertificateAttached === "Yes" ? false : true
                  // }
                  validTypes={[".pdf"]}
                  // accept="image/pdf,video/mp4,audio/mpeg"
                  accept=".pdf"
                  value={data.ballotPdf}
                  onChange={(val) => uploadChangeHandler("ballotPdf", val)}
                  required={true}
                  size={2048} //2 mb in kilobits
                  getError={(val) => getErrorValue("ballotPdf", val)}
                  Error={errorValue}
                  resetFile={(ev) => resetFile(data.ballotPdf, "ballotPdf")}
                  reference={ref}
                />
                <p className="text-danger ml-3">
                  Max Size 2MB (only .pdf supported)
                </p>
              </div>
            </div>
          ) : null}

          {files ? (
            <>
              <div className="pdf-view-render">
                <iframe
                  width="100%"
                  height="500px"
                  src={URL.createObjectURL(files)}
                ></iframe>
              </div>
              <div className="row pdf-btn-row">
                <Button
                  value="Preview"
                  btnClass="pdf-btn"
                  onClick={() => {
                    const fileURL = URL.createObjectURL(files);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                    if (data.ballotPdf && data.ballotPdf !== "") {
                      setIsPreviewed(true);
                    }
                  }}
                  fa_icon="fa-solid fa-eye"
                  disabled={!files}
                />
                {isPreviewed ? (
                  epbdetails?.payload?.epbPaperFlag === "Y" ? null : (
                    <Button
                      value="save"
                      onClick={() => setShowConfirmationPopupToSaveBallot(true)}
                      btnClass="pdf-btn"
                      disabled={!files}
                      fa_icon="fa-solid fa-floppy-disk"
                    />
                  )
                ) : null}

                <Button
                  value="download"
                  btnClass="pdf-btn"
                  fa_icon="fa-solid fa-download"
                  disabled={!files}
                  onClick={() => {
                    const fileURL = URL.createObjectURL(files);
                    // Setting various property values
                    let alink = document.createElement("a");
                    alink.href = fileURL;
                    alink.download = `${userState}_${constType}_${userAc}_ballot.pdf`;
                    alink.click();
                  }}
                />
              </div>
            </>
          ) : null}

          {/* <div className="request-button mb-2 ">
      <Link
        to="ceo/returning-officer/approval-of-epb"
        className="button-link"
      >
        REQUEST APPROVAL
      </Link>
    </div> */}
          {/* <Link to="/returning-officer-finalepb" className='button-link'>REQUEST APPROVAL</Link> */}
        </div>
      </div>
    </>
  );
}
